export const SIGN_UP_API = 'http://localhost:80/iam/oauth2/sign_up'
export const SIGN_IN_API = 'http://localhost:80/iam/oauth2/sign_in'
export const publicUrl = process.env.PUBLIC_URL + '/'